import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

export const RemainderApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRemainder: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
      }
    >({
      query: ({ search } = {}) => ({
        url: `${END_POINTS.getRemainder}${
          search && search.trim() !== ""
            ? `?search=${encodeURIComponent(search)}`
            : ""
        }`,
        method: "GET",
      }),
    }),
    getRemainderById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getRemainderById}/${id}/`,
        method: "GET",
      }),
    }),
    addRemainder: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addRemainder,
        method: "POST",
        body,
      }),
    }),

    updateRemainder: builder.mutation<
      CommonResponseType,
      { body: any; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.addRemainder}?id=${id}`,
        method: "POST",
        body,
      }),
    }),

    deleteRemainder: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteRemainder}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetRemainderQuery,
  useLazyGetRemainderByIdQuery,
  useAddRemainderMutation,
  useUpdateRemainderMutation,
  useDeleteRemainderMutation,
} = RemainderApi;
